<template>
	<div>
		<div class="title">
			<div id="notice">
				<h5>财务延迟付款&nbsp;&nbsp;说明:</h5><br>
				<span
					class="red">1、单号类型:YS=运输单、YF=运费申请单、BX=个人报销单、JK=个人借款单、XZ=个人销账单、SJ=司机费用报销、ZB=增补费、JW=就位费、BX=保险费、KL=看路费。</span><br>
				<span>2、双击显示明细信息,确定是否通过。</span><br>
				<span class="red">3、默认查询未打款或未确认数据。</span><br>
				<span>4、查询关键字:单号、打款状态、收款人、厂家、打款金额、打款类型、打款开始日期、打款截止日期、更新日期</span><br>

			</div>
		</div>

		<pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">

			<!-- <template slot="slot_c_out_fee">
        <pre-select class="short0" ref="out_fee" @selectFunc="selectFunc1" v-bind:searchList="list_fee"
          :selectValue="sel_fee" />
      </template> -->

		</pre-base>
	</div>
</template>

<script>
	export default {
		components: {
			"pre-base": () => import("../auto/old_view_v1.vue"),
		},
		data() {
			return {
				init_data: '',
				row_id: '',
				item: '',
				// 下拉菜单
				// list_fee: [],
				// sel_fee: {},
			};
		},
		mounted: function() {
			var that = this;
			this.$nextTick(function() {
				that.fun_init();
			});
		},
		methods: {
			fun_init: function() {

				this.init_data = '';
				this.init_data = JSON.stringify({
					"title": '财务付款延迟',
					"control": "cwpaylate",
					"isTwo": "1",
					"isTwoDetail": "1",
					"action_flag": "",
					"isFileMain": "0",
					"step": "0",
					"sel_action": 'exp_cw_fee_pay_m_late',
					"upd_action": 'exp15_cw_pay_m_late',
					"detail_part": "1",
					"d_btn_more": "0",
					"d_sel_action": 'exp_cw_fee_pay_d_late',
					"d_upd_action": '_cw_pay_d_late',
					"file_action": 'cw_pay_late',
					"p1": 'cw',
					"p2": 'pay',
					"p3": '',
					"parm_sel": [{
							"name": "单号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1",
							"sel": "1"
						},
						{
							"name": "状态",
							"val": "",
							"key": "flag",
							"type": "select",
							"class": "long1",
							"sel_action": "data_flag",
							"sel_name": "",
							"sel": "2"
						},
						{
							"name": "收款人",
							"val": "",
							"key": "u2_name",
							"type": "text",
							"class": "long1",
							"sel": "3"
						},
						{
							"name": "厂家",
							"val": "",
							"key": "c_name",
							"type": "text",
							"class": "long1",
							"sel": "4",
						},
						{
							"name": "打款金额",
							"val": "",
							"key": "pay_amount",
							"type": "number",
							"class": "long1",
							"sel": "5",
						},
						{
							"name": "打款划分",
							"val": "",
							"key": "pay_flag",
							"type": "select",
							"class": "long1",
							"sel_action": "_base_pay_flag",
							"sel_name": "",
							"sel": "6"
						},
						{
							"name": "打款开始日期",
							"val": "",
							"key": "s_date",
							"type": "date",
							"class": "long1",
							"sel": "7",
						},
						{
							"name": "打款截至日期",
							"val": "",
							"key": "e_date",
							"type": "date",
							"class": "long1",
							"sel": "8",
						},
						{
							"name": "更新日期",
							"val": "",
							"key": "sys_date",
							"type": "date",
							"class": "long1",
							"sel": "9",
						}
					],
					"parm": [
						{
							"name": "业务单号",
							"val": "",
							"key": "sheet_no",
							"type": "label",
							"class": "black",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "申请人",
							"val": "",
							"key": "sq_name",
							"type": "label",
							"class": "black",
							"p": "0",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "收款人",
							"val": "",
							"key": "rec_user",
							"type": "label",
							"class": "black",
							"p": "0",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "收款账号",
							"val": "",
							"key": "rec_card",
							"type": "label",
							"class": "black",
							"p": "0",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "合计金额",
							"val": "",
							"key": "pass_all",
							"type": "label",
							"class": "red",
							"p": "0",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "待审收入",
							"val": "",
							"key": "in_amount",
							"type": "label",
							"class": "black",
							"p": "0",
							"w": "0",
							"r": "0",
							"x": "2"
						},
						{
							"name": "待审已付",
							"val": "",
							"key": "bef_amount",
							"type": "label",
							"class": "black",
							"p": "0",
							"w": "0",
							"r": "0",
							"x": "2"
						},
						{
							"name": "待审支出",
							"val": "",
							"key": "out_amount",
							"type": "label",
							"class": "black",
							"p": "0",
							"w": "0",
							"r": "0",
							"x": "2"
						},
						{
							"name": "审核收入",
							"val": "",
							"key": "in_ok",
							"type": "label",
							"class": "red",
							"p": "0",
							"w": "0",
							"r": "0",
							"x": "3"
						},
						{
							"name": "审核已付",
							"val": "",
							"key": "bef_ok",
							"type": "label",
							"class": "red",
							"p": "0",
							"w": "0",
							"r": "0",
							"x": "3"
						},
						{
							"name": "审核支出",
							"val": "",
							"key": "out_ok",
							"type": "label",
							"class": "red",
							"p": "0",
							"w": "0",
							"r": "0",
							"x": "3"
						},
						{
							"name": "首付状态",
							"val": "",
							"key": "pay_flag",
							"type": "label",
							"p": "0",
							"w": "0",
							"r": "0",
							"x": "4"
						},
						{
							"name": "首付金额",
							"val": "",
							"key": "pay_amount",
							"type": "label",
							"p": "0",
							"w": "0",
							"r": "0",
							"x": "4"
						},
						{
							"name": "首付日期",
							"val": "",
							"key": "pay_date",
							"type": "label",
							"p": "0",
							"w": "0",
							"r": "0",
							"x": "4"
						},
						{
							"name": "分期金额合计",
							"val": "",
							"key": "pay_late",
							"type": "label",
							"p": "0",
							"w": "0",
							"r": "0",
							"x": "4"
						},
						{
							"name": "备注",
							"val": "",
							"key": "p_note",
							"type": "text",
							"class": "long2",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "4"
						},
						{
							"name": "补充说明",
							"val": "",
							"key": "sheet_note",
							"type": "textarea",
							"class": "long5",
							"p": "0",
							"w": "0",
							"r": "1",
							"x": "5"
						}
					],
					"parm_th": [{
							"name": "序号"
						},
						{
							"name": "单号"
						},
						{
							"name": "厂家"
						},
						{
							"name": "起点"
						},
						{
							"name": "终点"
						},
						{
							"name": "货名"
						},
						{
							"name": "申请人",
							"class": "short0"
						},
						{
							"name": "状态",
							"class": "short0"
						},
						{
							"name": "收入费用"
						},
						{
							"name": "确认收入"
						},
						{
							"name": "已付费用"
						},
						{
							"name": "确认已付"
						},
						{
							"name": "支出费用"
						},
						{
							"name": "确认支出"
						},
						{
							"name": "合计金额"
						},
						{
							"name": "明细费用备注",
							"class": "long2"
						},
						{
							"name": "收款人"
						},
						{
							"name": "收款账号"
						},
						{
							"name": "发货日期"
						},
						{
							"name": "打款状态",
							"class": "short0"
						},
						{
							"name": "首次打款"
						},
						{
							"name": "打款日期"
						},
						{
							"name": "延迟打款"
						},
						{
							"name": "打款凭证"
						},
						{
							"name": "核对人",
							"class": "short0"
						},
						{
							"name": "核对备注",
							"class": "long2"

						},
						{
							"name": "申请日期"
						},
						{
							"name": "审批人",
							"class": "short0"
						},
						{
							"name": "审批人备注",
							"class": "long2"
						},
						{
							"name": "审批日期"
						},
						{
							"name": "打款人",
							"class": "short0"
						},
						{
							"name": "打款人备注",
							"class": "long2"
						},
						{
							"name": "打款操作日期"
						},
						{
							"name": "总运费",
							"class": "short0"
						},
						{
							"name": "已付现金",
							"class": "short0"
						},
						{
							"name": "已付油",
							"class": "short0"
						},
						{
							"name": "未付现金",
							"class": "short0"
						},

						{
							"name": "未付油",
							"class": "short0"
						},
						{
							"name": "存储路径"
						},
						{
							"name": "访问路径"
						},
						{
							"name": "更新时间"
						}
					],
					"d_parm": [
						{
							"name": "单号",
							"val": "",
							"key": "sheet_no",
							"type": "none",
							"w": "0",
							"p": "1"
						},
						{
							"name": "打款状态",
							"val": "",
							"key": "pay_flag",
							"type": "selectnew",
							"class": "long1",
							"sel_action": "_base_pay_flag",
							"sel_name": "",
							"p": "1",
							"w": "0"
						},
						{
							"name": "打款金额",
							"val": "",
							"key": "pay_amount",
							"type": "number",
							"class": "long1",
							"p": "1",
							"w": "1"
						},
						{
							"name": "打款日期",
							"val": "",
							"key": "pay_date",
							"type": "date",
							"class": "long1",
							"p": "1",
							"w": "0",
						},
						{
							"name": "备注",
							"val": "",
							"key": "note",
							"type": "text",
							"class": "long3",
							"p": "1",
							"w": "0"
						}
					],
					"d_name": [{
							"name": "ID"
						},
						{
							"name": "序号"
						},
						{
							"name": "单号"
						},
						{
							"name": "打款状态"
						},
						{
							"name": "打款金额"
						},
						{
							"name": "打款日期"
						},
						{
							"name": "备注"
						},
						{
							"name": "附件"
						},
						{
							"name": "修改人"
						},
						{
							"name": "更新时间"
						},
						{
							"name": "路径1"
						},
						{
							"name": "路径2"
						}
					]
				});



			},
			refresh_data: function(type) {
				var that = this;
				this.$nextTick(function() {
					that.$refs['mybase'].refresh_data(type);
				});
			},
			refresh_father: function(type, val, parm) {
				// console.log('type=' + type + ' val=' + val);
				switch (type) {
					case 'father':
						// 弹出修改明细，修改主窗口信息
						this.refresh_data();
						break;
					default:
						// console.log('子组件刷新父组件传值=' + val);
						this.row_id = val;
						this.item = parm;
						break;
				}
			}






		}
	};
</script>
<style>
</style>